document.addEventListener('DOMContentLoaded', () => {
  // Respect reduced motion like Elementor does
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.jp-anim').forEach(el => el.classList.add('jp-anim--in'));
    return;
  }

  const map = {
    fadeIn: 'jpFadeIn',
    fadeInUp: 'jpFadeInUp',
    fadeInDown: 'jpFadeInDown',
    fadeInLeft: 'jpFadeInLeft',
    fadeInRight: 'jpFadeInRight',
    zoomIn: 'jpZoomIn',
    zoomInUp: 'jpZoomInUp',
    slideInUp: 'jpSlideInUp',
    slideInLeft: 'jpSlideInLeft',
    slideInRight: 'jpSlideInRight',
    rotateIn: 'jpRotateIn',
    bounceIn: 'jpBounceIn'
  };

  const els = document.querySelectorAll('.jp-anim');
  if (!els.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;

      const el = e.target;
      const anim = el.dataset.jpAnim || 'fadeInUp';
      const duration = el.dataset.jpDuration || '0.8s';
      const delay = el.dataset.jpDelay || '0s';
      const ease = el.dataset.jpEase || 'ease-out';

      el.style.setProperty('--jp-anim-name', map[anim] || map.fadeInUp);
      el.style.setProperty('--jp-anim-duration', duration);
      el.style.setProperty('--jp-anim-delay', delay);
      el.style.setProperty('--jp-anim-ease', ease);

      el.classList.add('jp-anim--in');
      io.unobserve(el);
    });
  }, { threshold: 0.15 });

  els.forEach(el => io.observe(el));
});
